import { type HttpRequestDiagnostics, HttpRequestError } from "@anna-money/anna-web-lib/api";
import { AnnaErrorBase, type AnnaErrorOptions } from "@anna-money/anna-web-lib/utils";

const customError = (error: Error, name: string, newTarget: Function): void => {
  Object.defineProperty(error, "name", {
    enumerable: false,
    writable: false,
    configurable: true,
    value: name,
  });

  Object.setPrototypeOf(error, newTarget.prototype);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(error, newTarget);
  } else {
    error.stack = new Error().stack;
  }
};

export class AuthenticationError extends HttpRequestError {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(diagnostics: HttpRequestDiagnostics, message: string, options?: AnnaErrorOptions) {
    super(diagnostics, message, options);
    customError(this, "AuthenticationError", new.target);
  }
}

export class DeauthenticationError extends HttpRequestError {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(diagnostics: HttpRequestDiagnostics, message: string, options?: AnnaErrorOptions) {
    super(diagnostics, message, options);
    customError(this, "DeauthenticationError", new.target);
  }
}

export class UnauthenticatedError extends AnnaErrorBase {
  constructor() {
    super("Authentication lost");
    customError(this, "UnauthenticatedError", new.target);
  }
}
